import React from 'react';
import ReactDOM from 'react-dom';
import ReactModal from 'react-modal';
import { I18nextProvider } from 'react-i18next';

import I18n from '../shared/I18n';

import { Login, Signup } from './pages';

export function renderLogin(element, { i18n, ...restProps }) {
  I18n.initialize(i18n.dictionary, i18n.language);

  ReactDOM.render(
    <I18nextProvider i18n={I18n.i18n}>
      <Login {...restProps} />
    </I18nextProvider>,
    element,
  );
}

export function renderSignup(element, { i18n, ...restProps }) {
  I18n.initialize(i18n.dictionary, i18n.language);
  ReactModal.setAppElement(element);

  ReactDOM.render(
    <I18nextProvider i18n={I18n.i18n}>
      <Signup {...restProps} />
    </I18nextProvider>,
    element,
  );
}
